import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from 'src/styles/dontgiftguide.styles';
const { fonts, text, colors } = dggTheme;

export const container = css`
  position: relative;
  width: 96px;
  height: 96px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: 190px;
      height: 190px;
    `,
  )}
  img {
    width: 100%;
    height: 100%;
  }
`;

export const contentWrapper = css`
  position: absolute;
  top: 0;
  display: flex;
  width: 100%;
  height: 100%;
  padding: ${pxToRem(4)} ${pxToRem(5)} ${pxToRem(4)} ${pxToRem(2)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      padding: 0 ${pxToRem(12)} ${pxToRem(6)} ${pxToRem(8)};
    `,
  )}
`;

export const content = css`
  margin: auto;
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-size: ${pxToRem(11)};
  transform: rotate(-15deg);
  white-space: break-spaces;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(text.HEADING.SM.fontSize)};
    `,
  )}
`;

export const contentLight = css`
  color: ${colors.neutralWhite};
`;

export const contentDark = css`
  color: ${colors.parisM};
`;
